import VisuallyHidden from '@reach/visually-hidden';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '../Typography';
import { Address, Compensation } from './icons';
import { ShiftHourRange } from './ShiftHourRange';
import { useStyles } from './styles';

export interface OpeningProps {
  title: string;
  address?: string;
  payRate?: string;
  minWeeklyHours?: number;
  maxWeeklyHours?: number;
  showCompensation: boolean;
}

export const Opening: FC<OpeningProps> = ({
  title,
  address,
  payRate,
  minWeeklyHours,
  maxWeeklyHours,
  showCompensation = true,
}) => {
  const classes = useStyles();

  const displayPayRate = showCompensation && Boolean(payRate);
  const displayLocationAndPayContainer = Boolean(address) || displayPayRate;

  return (
    <div className={classes.container}>
      <Typography variant="headingLG">{title}</Typography>
      {displayLocationAndPayContainer && (
        <div
          data-testid="location-and-pay-container"
          className={classes.locationAndPay}
        >
          {address && (
            <div className={classes.innerText}>
              <VisuallyHidden>
                <FormattedMessage
                  defaultMessage="Address"
                  description="Accessibility label for screen readers describing Address icon"
                />
              </VisuallyHidden>
              <Address className={classes.icons} />
              {address && <Typography>{address}</Typography>}
            </div>
          )}
          {displayPayRate && (
            <div className={classes.innerText}>
              <VisuallyHidden>
                <FormattedMessage
                  defaultMessage="Compensation"
                  description="Accessibility label for screen readers describing Compensation icon"
                />
              </VisuallyHidden>
              <Compensation className={classes.icons} />
              <Typography>{payRate}</Typography>
            </div>
          )}
          <ShiftHourRange
            minWeeklyHours={minWeeklyHours}
            maxWeeklyHours={maxWeeklyHours}
            styles={{ root: classes.innerText, icon: classes.icons }}
          />
        </div>
      )}
    </div>
  );
};
